import { render } from "./ValidateProvider.vue?vue&type=template&id=c82eea6a"
import script from "./ValidateProvider.vue?vue&type=script&lang=js"
export * from "./ValidateProvider.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\Сurrent_Projects\\inter-qr\\web-updates\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__